import { centralEnabled, centralAccessToken } from './centralAuth';
import axios from "axios";
import { appEnv } from "../config/env";
import { BaseService } from "./BaseService";

export interface DomainDnsRecord {
  Type: string;
  Name: string;
  FullyQualifiedName: string;
  Value: string;
  Ttl: number;
}
export interface SiteDomainStatus {
  Id: string;
  SiteId: string;
  Hostname: string;
  State: string;
  OwnershipVerified: boolean;
  TokenExpiresUtc: string | null;
  LastCheckedUtc: string | null;
  NextCheckUtc: string;
  Error: string | null;
  DnsRecords: DomainDnsRecord[];
}
export interface SiteDomainList {
  Enabled: boolean;
  CanAdd: boolean;
  PublishedDomain: string | null;
  Domains: SiteDomainStatus[];
}

export class SiteDomainService extends BaseService {
  private url(siteId: string, suffix = "") {
    return `${appEnv.apiUrl ?? ""}/sites/${encodeURIComponent(siteId)}/domains${suffix}`;
  }
  async list(siteId: string, signal?: AbortSignal): Promise<SiteDomainList> {
    if (centralEnabled) await centralAccessToken();
    return (await axios.get<SiteDomainList>(this.url(siteId), { headers: this._ajaxService.GetHeaders(true), signal })).data;
  }
  async create(siteId: string, hostname: string): Promise<SiteDomainStatus> {
    if (centralEnabled) await centralAccessToken();
    return (await axios.post<SiteDomainStatus>(this.url(siteId), { Hostname: hostname }, { headers: this._ajaxService.GetHeaders(true) })).data;
  }
  async change(siteId: string, id: string, action: "check" | "renew-validation" | "delete"): Promise<SiteDomainStatus> {
    if (centralEnabled) await centralAccessToken();
    const path = `/${encodeURIComponent(id)}`;
    const headers = this._ajaxService.GetHeaders(true);
    return action === "delete"
      ? (await axios.delete<SiteDomainStatus>(this.url(siteId, path), { headers })).data
      : (await axios.post<SiteDomainStatus>(this.url(siteId, `${path}/${action}`), {}, { headers })).data;
  }
}

export function domainError(error: unknown): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    if (data?.Message || data?.detail) return data.Message ?? data.detail;
    if (error.response?.status === 403) return "Only the site owner or an administrator can manage its domain.";
  }
  return "Unable to update domain setup. Please try again.";
}
